// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 7642 ? "94a7ad86" : chunkId) + "." + {"7642":"ae3f4150b03afa39","7680":"f35a42f57918629c"}[chunkId] + ".js";
};